<template>
  <div class="section-roles section-5" ref="roles">
    <div class="bg img-box">
      <img v-lazy="'https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/bg.png'">
    </div>
    <div class="hero-introduce">
      <div
        class="hero-container"
        v-for="hero in heroes"
        :key="hero.name"
        :class="hero.name"
        v-show="hero.name == subHeroName"
      >
        <div class="bg-role img-box">
          <img v-lazy="'https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/lie_bg.png'"/>
        </div>
        <div class="role">
          <div
            class="specialty-box"
            v-for="(item, key) in lg(hero, 'specialty', [])"
            :key="key"
          >
            <div
              v-show="item.id == subHeroID"
              class="vertical img-box"
              :class="item.id"
            >
              <img v-lazy="lg(item, 'lie_app', '')" />
            </div>
          </div>
        </div>

        <div class="skill">
          <div class="name-box">
            <div class="name">
              {{ subLocale[hero.name] }}
              <div class="name-abb">{{ hero.name.toUpperCase() }}</div>
            </div>
            <div class="name-nick">{{ subLocale[`${hero.name}_before`] }}</div>
          </div>
          <div class="video-box">
            <img class="video-frame" v-lazy="'https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/pc/video_frame.png'">
            <div
              v-for="(item, i) in lg(hero, 'specialty', [])"
              :key="i"
              :name="`video_${item.id}`"
              class="video img-box"
              v-show="item.id == lg(hero, 'subHeroID', '')"
              @click="openVideoModal(lg(item, 'video', ''))"
            >
              <img class="video-poster" v-lazy="lg(item, 'video_poster', '')"/>
              <div class="mask"></div>
              <img class="player" v-lazy="'https://website.xdcdn.net/homepage/torchlight/imgs/overseas/add2022/btn_player.png'">
            </div>
          </div>
          <div class="hero-introduction">
            <div class="title">{{ subLocale['intro_title'] }}</div>
            <div class="introduction">
              <span
                v-for="(item, key) in lg(hero, 'specialty', [])"
                :key="key"
                v-show="item.id == lg(hero, 'subHeroID', '')"
              >{{ subLocale[`${lg(item, 'intro', '')}`] }}</span>
            </div>
          </div>
          <div class="skill-container">
            <div
              v-for="(item, key) in lg(hero, 'specialty', [])"
              :key="key"
              class="specialty-box specialty-skillBox"
              :class="{ active: item.id == lg(hero, 'subHeroID', '') }"
              @click="switchHero(subHeroName, item.id)"
            >
              <div class="icon-box">
                <div class="icon img-box">
                  <img v-lazy="lg(item, 'icon', '')" />
                </div>
                <img
                  class="default"
                  v-lazy="'https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/pc/skill_default_btn.png'"
                />
                <img
                  class="active"
                  v-lazy="'https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/pc/skill_active_btn.png'"
                />
              </div>
              <p>{{ subLocale[`${lg(item, 'skill', '')}`] }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="icon-left img-box" @click="prevHero">
      <img v-lazy="'https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/icon-left.png'">
    </div>
    <div class="icon-right img-box" @click="nextHero">
      <img v-lazy="'https://website.xdcdn.net/homepage/torchlight/imgs/v2.0/mobile/icon-right.png'">
    </div>

    <modal-video ref="modalVideo" />
    <xd-video class="init-video" />
  </div>
</template>

<script>
import * as initAnime from "../libs/initAnimeApp";
// import jsonEn from '../json/updateEn.json';
import _lg from "../libs/lg";
import XdVideo from "../components/xdvideo.vue";
import ModalVideo from "../components/modal-video.vue";
import Hammer from 'hammerjs';

export default {
  components: { XdVideo, ModalVideo },
  props: {
    heroes: {
      type: Array,
      default: () => [],
    },
    subHeroName: {
      type: String,
      default: () => "",
    },
    subHeroID: {
      type: String,
      default: () => "",
    },
    subLocale: {
      type: Object,
      default: () => {},
    },
    appOnly: {
      type: Boolean,
      default: () => false,
    },
    lang: {
      type: String
    },
  },
  data() {
    return {
      initFixBottomTop: 0,
      fixBottomTop: 0,
      fixBottomMax: 0,
      isFix: false,
      unfix: false,
      switchStep: {
        start: 2,
        length: 0,
        total: 3,
        step: 0,
        stepWidth: 29,
      },
      switchTimer: "",
      inSwitch: false,
      lg: _lg,
    };
  },
  watch: {
    heroes: {
      handler(newVal, oldVal) {
        if (newVal != oldVal && newVal.length != 0) {
          this.$nextTick(() => {
            this.initTransitions();
          });
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.initHammer();
  },
  methods: {
    switchHero(name, id = "", i = "") {
      if (!this.inSwitch) {
        this.inSwitch = true;

        this.$emit("switch-hero", { name, id });
        // if (typeof i == "number") {
        //   this.handleStep(i + 1);
        // }

        this.switchTimer = setTimeout(() => {
          this.inSwitch = false;
        }, 1500);
      }
    },
    initTransitions() {
      let transitions = {};
      this.heroes.forEach((hero) => {
        transitions[hero.name] = initAnime.introduce(".section-roles", hero);
      });

      // 初始化完成，播放默认英雄动画
      transitions[this.subHeroName] && transitions[this.subHeroName].restart();
      this.$emit("init-transitions-end", transitions);
    },
    openVideoModal(video) {
      // const subHeroID = this.subHeroID;
      // const targetMap = this.heroes;
      // const targetName = (subHeroID.match(/^([a-zA-Z])*/) || [])[0];
      // let video = null;

      // for (const item of targetMap) {
      //   if (item.name === targetName) {
      //     for (const innerItem of item.specialty) {
      //       if (innerItem.id === subHeroID) {
      //         video = innerItem.video;
      //         break;
      //       }
      //     }
      //   }
      // }

      if (!video) return;

      this.$refs.modalVideo.createModalVideo({
        autoplay: false,
        video: video,
        autoFullScreen: true,
      });
    },
    handleStep(i) {
      if (!this.switchStep["length"]) {
        this.switchStep["length"] = this.heroes.length;
      }

      let index_start = i - this.switchStep["start"];
      if (index_start > 0) {
        let length_total = this.switchStep["length"] - this.switchStep["total"];
        if (index_start <= length_total) {
          this.switchStep["step"] = index_start;
        } else {
          this.switchStep["step"] = length_total;
        }
      } else {
        this.switchStep["step"] = 0;
      }

      let clientWidth =
        this.appOnly && document.documentElement.clientWidth > 500
          ? 500
          : document.documentElement.clientWidth;
      this.$refs.heroSwitch.scrollLeft =
        this.switchStep["step"] *
        (this.switchStep["stepWidth"] / 100) *
        clientWidth;
    },
    prevHero() {
      let thisHero = this.heroes.find(item => item.name == this.subHeroName);
      let thisIndex = this.heroes.indexOf(thisHero);
      if(thisIndex >= 1) {
        let prevIndex = thisIndex - 1;
        let prevHero = this.heroes[prevIndex];
        this.switchHero(prevHero['name'], prevHero['subHeroID'], prevIndex);
      }else {
        let prevIndex = this.heroes.length - 1;
        let prevHero = this.heroes[prevIndex];
        this.switchHero(prevHero['name'], prevHero['subHeroID'], prevIndex);
      }
    },
    nextHero() {
      let thisHero = this.heroes.find(item => item.name == this.subHeroName);
      let thisIndex = this.heroes.indexOf(thisHero);
      if(thisIndex < this.heroes.length - 1) {
        let nextIndex = thisIndex + 1;
        let nextHero = this.heroes[nextIndex];
        this.switchHero(nextHero['name'], nextHero['subHeroID'], nextIndex);
      }else {
        // 回到第一个
        let nextIndex = 0;
        let nextHero = this.heroes[nextIndex];
        this.switchHero(nextHero['name'], nextHero['subHeroID'], nextIndex);
      }
    },
    initHammer() {
      var hammer = new Hammer(this.$refs.roles);
      hammer.on('swipeleft', () => {
        this.nextHero()
      });
      hammer.on('swiperight', () => {
        this.prevHero()
      });
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/mixin.scss";
@import "../scss/files.scss";

.img-box {
  display: flex;
  justify-content: center;
  img {
    // width: 100%;
    height: 100%;
  }
}
.section-roles {
  position: relative;
  // @include app_section_bg('mobile_section5_bg');
  width: vwApp(828px);
  height: vwApp(1808px);
  >.bg {
    position: absolute;
    width: 100%;
    height: vwApp(1251px);
    bottom: vwApp(10px);
    left: 0;
  }

  .hero-introduce {
    position: relative;
    width: vwApp(828px);
    height: 100%;
    margin: 0 auto;
    overflow: hidden;

    .hero-container {
      position: relative;
      overflow: hidden;
      width: 100%;
      height: 100%;
      .bg-role {
        width: vwApp(632px);
        height: vwApp(1099px);
        position: absolute;
        top: 0;
        right: 0;
      }
      .role {
        width: vwApp(828px);
        height: vwApp(1585px);
        position: absolute;
        top: vwApp(50px);
        left: 0;
        transform-origin: left bottom;
        @include gpu-for-transition();
        .specialty-box {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          .vertical {
            width: 100%;
            height: 100%;
            img {
              width: 100%;
              height: auto;
              object-fit: contain;
            }
          }
        }
      }

      .skill {
        position: absolute;
        width: vwApp(746px);
        bottom: vwApp(67px);
        left: 50%;
        margin-left: vwApp(-373px);
        .name-box {
          display: inline-block;
          position: relative;
          color: #fff;
          font-weight: bolder;
          transform: translate3d(0, 0, 0);
          .name {
            position: relative;
            display: table;
            font-size: vwApp(90px);
            transform: matrix(1, 0, -0.15, 0.98, 0, 0);
            white-space: nowrap;
            line-height: 1.1;
            margin-bottom: -1vw;
            .name-abb {
              font-size: vwApp(30px);
              transform: matrix(1, 0, -0.22, 0.98, 0, 0);
              font-weight: bolder;
              position: absolute;
              top: vwApp(-20px);
              right: 0;
              display: none;
            }
          }
          .name-nick {
            font-size: vwApp(35px);
            transform: matrix(1, 0, -0.15, 0.98, 0, 0);
            white-space: nowrap;
            line-height: 1.1;
            // position: absolute;
            // bottom: 0;
            // left: 0;
          }
        }

        .video-box {
          position: relative;
          width: vwApp(746px);
          height: vwApp(471px);
          transform: translate3d(0, 0, 0);
          margin-top: 2vw;
          .video-frame {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
          }
          .video {
            width: vwApp(740px);
            height: vwApp(414px);
            position: absolute;
            top: vwApp(3px);
            left: vwApp(3px);
            clip-path: polygon(0% 0%, 100% 0%, 100% 83%, 93% 100%, 0% 100%);
            background-color: black;
            padding-top: 0;
            cursor: pointer;
            .video-poster, .mask {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
            }
            .mask {
              background-color: rgba(0, 0, 0, 0.3);
            }
            .player {
              width: vwApp(120px);
              height: vwApp(120px);
              position: absolute;
              left: 50%;
              top: 50%;
              margin-left: vwApp(-60px);
              margin-top: vwApp(-60px);
            }
          }
        }

        .hero-introduction {
          color: #fff;
          margin-top: vwApp(-40px);
          min-height: vwApp(210px);
          transform: translate3d(0, 0, 0);
          .title {
            font-size: vwApp(38px);
            font-weight: bold;
          }
          .introduction {
            font-size: vwApp(28px);
            white-space: pre-wrap;
          }
        }
        .skill-container {
          margin: 0 auto;
          padding-top: vwApp(15px);
          overflow: hidden;
          display: flex;
          justify-content: center;
          .specialty-box {
            width: vwApp(180px);
            margin: 0 vwApp(10px);
            -webkit-tap-highlight-color: transparent;
            transform: translate3d(0, 0, 0);
            .icon-box {
              position: relative;
              width: vwApp(104px);
              height: vwApp(104px);
              cursor: pointer;
              margin: 0 auto;
              >.default {
                width: 100%;
                height: 100%;
                position: absolute;
                top:0;
                left: 0;
                transition: all ease-in-out 200ms;
              }
              >.active {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0px;
                opacity: 0;
                transition: all ease-in-out 200ms;
              }

              .icon {
                width: vwApp(82px);
                height: vwApp(82px);
                position: absolute;
                left: 50%;
                top: 50%;
                margin-left: vwApp(-41px);
                margin-top: vwApp(-41px);
              }
            }
            p {
              text-align: center;
              color: #fff;
              font-size: vwApp(28px);
              font-weight: bold;
              margin-top: vwApp(10px);
            }

            &.active {
              .icon-box {
                .active {
                  opacity: 1;
                }
                .default {
                  opacity: 0;
                }
              }
            }
          }
        }
      }
    }
  }
  .init-video {
    width: 0;
    height: 0;
    overflow: hidden;
  }

  .icon-left {
    width: vwApp(53px);
    height: vwApp(57px);
    position: absolute;
    top: vwApp(500px);
    left: vwApp(42px);
  }
  .icon-right {
    width: vwApp(53px);
    height: vwApp(57px);
    position: absolute;
    top: vwApp(500px);
    right: vwApp(42px);
  }
}
</style>